module.exports = __webpack_public_path__ + "static/img/12.330513e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/12.jpg
// module id = RGYs
// module chunks = 16